import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export default function InquiryForm({ property }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/inquiries", {
        ...form,
        property_id: property?.id || null,
        property_title: property?.title || null,
      });
      toast.success("Enquiry sent. Our team will respond within one business day.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      const status = err.response?.status;
      if (status === 422) {
        toast.error("Please enter a valid email address and try again.");
      } else {
        toast.error("Something went wrong. Please try again, or email harry@rubino.se directly.");
      }
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "rounded-none border-0 border-b border-border bg-transparent px-0 focus-visible:ring-0 focus-visible:border-foreground h-12";

  return (
    <form onSubmit={submit} data-testid="inquiry-form" className="space-y-6">
      <div className="grid sm:grid-cols-2 gap-6">
        <Input data-testid="inquiry-name" required placeholder="Full name" value={form.name} onChange={set("name")} className={inputCls} />
        <Input data-testid="inquiry-email" required type="email" placeholder="Email" value={form.email} onChange={set("email")} className={inputCls} />
      </div>
      <Input data-testid="inquiry-phone" placeholder="Phone (optional)" value={form.phone} onChange={set("phone")} className={inputCls} />
      <Textarea data-testid="inquiry-message" required rows={4} placeholder={property ? `I'd like to enquire about ${property.title}...` : "Tell us about your requirements..."} value={form.message} onChange={set("message")} className="rounded-none border-0 border-b border-border bg-transparent px-0 focus-visible:ring-0 focus-visible:border-foreground resize-none" />
      <button
        data-testid="inquiry-submit"
        disabled={loading}
        className="group relative overflow-hidden border border-foreground px-8 py-4 overline hover-invert hover:bg-foreground hover:text-background disabled:opacity-50"
      >
        {loading ? "Sending…" : "Send enquiry"}
      </button>
    </form>
  );
}
